import { render, staticRenderFns } from "./ProductCards.vue?vue&type=template&id=3db6568c"
import script from "./ProductCards.vue?vue&type=script&lang=js"
export * from "./ProductCards.vue?vue&type=script&lang=js"
import style0 from "./ProductCards.vue?vue&type=style&index=0&id=3db6568c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports